import { forEach } from "lodash-es";
import addOrUpdate from "./addOrUpdate";

export default function(objects: any[][] = [], data: any[] = [], checks: string[] = ["id"]) {
  forEach(data, v => {
    forEach(objects, o => addOrUpdate(o, v, checks))
  })
  return objects
}